import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var FontSize = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.7 32.838c.4.4.4 1.098 0 1.498l-5.592 5.594c-.399.4-1.098.4-1.497 0l-5.592-5.594c-.4-.4-.4-.999 0-1.498.399-.4.998-.4 1.497 0l3.795 3.795V7.366l-3.795 3.795c-.4.4-.998.4-1.497 0-.4-.4-.4-1.098 0-1.498L36.61 4.07c.399-.4 1.098-.4 1.497 0L43.7 9.663c.4.4.4.999 0 1.498-.399.4-.998.4-1.497 0l-3.795-3.795v29.367l3.795-3.795c.499-.5 1.098-.5 1.497-.1ZM27.723 38.731l-3.695-9.989L14.941 4.67c-.2-.4-.499-.7-.998-.7-.4 0-.8.3-.999.7L.063 38.63c-.2.5.1 1.1.599 1.299.499.2 1.098-.1 1.298-.6l3.495-9.19H22.23l3.495 9.19c.2.5.799.8 1.298.6.7-.1.899-.7.7-1.199ZM6.253 28.143l7.69-20.178 7.589 20.178H6.254Z"
  }));
});
FontSize.displayName = 'FontSize';
FontSize.defaultProps = {
  'aria-label': 'FontSize'
};
export default FontSize;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Editor/FontSize.js
// module id = 2923
// module chunks = 11